import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Card, Col, Modal, Row } from 'react-bootstrap';
import MessageAlertRow from './MessageAlertRow';
import MessageForm from './MessageForm';
import { getPolicyList } from '../../../actions/message-policy';
import { CardContainer, DataTable, Heading5, Icon } from '../../widgets';
import '../../../../assets/scss/message-policy.scss';

const MessageAlert = () => {
  const { farmId } = useParams();
  const dispatch = useDispatch();

  const [AddPolicy, setAddPolicy] = useState(false);

  const policyList = useSelector(state => state.messagePolicy.list);
  const isRequesting = useSelector(state => state.messagePolicy.isRequesting);
  const isEGReuesting = useSelector(state => state.equipmentGroup.isRequesting);

  useEffect(() => { dispatch(getPolicyList(farmId)); }, []);

  return (
    <CardContainer lg={12} md={12} className='meaasge-policy'>
      <Card className='card-list equipment-list'>
        <Card.Header>
          <Card.Title>
            <Heading5>SMS Configuration List</Heading5>
            <Button
              variant='success'
              size='sm'
              title='Add Configuration'
              className='float-right'
              disabled={isEGReuesting || isRequesting}
              onClick={() => setAddPolicy(!AddPolicy)}>
              <Icon className='fa fa-plus'></Icon> Add
            </Button>
          </Card.Title>
        </Card.Header>
        <Card.Body>
          <Row>
            <Col>
              <DataTable>
                <DataTable.Header>
                  <DataTable.Row>
                    <DataTable.Cell style={{ width: '40px' }}>#</DataTable.Cell>
                    <DataTable.Cell>Name</DataTable.Cell>
                    <DataTable.Cell>Type</DataTable.Cell>
                    <DataTable.Cell>Phone</DataTable.Cell>
                    <DataTable.Cell>Configuration</DataTable.Cell>
                    <DataTable.Cell style={{ width: '64px' }}>Action</DataTable.Cell>
                  </DataTable.Row>
                </DataTable.Header>
                <DataTable.Body>
                  {policyList.map((e, i) => (
                    <MessageAlertRow
                      data={e}
                      index={i}
                      farmId={farmId}
                    />
                  ))}
                </DataTable.Body>
              </DataTable>
              {isRequesting ? <DataTable.Loading /> :
                policyList.length === 0 && <DataTable.RecordsNotFound />}
            </Col>
          </Row>
        </Card.Body>
      </Card>
      {<Modal
        show={AddPolicy}
        backdrop='static'
        className='equipment-modal-form'>
        <MessageForm
          onHide={(e) => setAddPolicy(e)}
          type={'add'}
        />
      </Modal>}
    </CardContainer>
  );
};

export default MessageAlert;